// API Configuration — backend origin (no /api suffix). Used as Vite proxy target in dev;
// in production builds, requests go to this host + /api unless you front both behind one domain.
export const API_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:3000'
export const API_TIMEOUT = 10000

// Application Info
export const APP_NAME = 'INN Admin'
export const APP_VERSION = '1.0.0'

// Pagination
export const DEFAULT_PAGE_SIZE = 10
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100]

// Date Formats
export const DATE_FORMAT = 'MM/DD/YYYY'
export const TIME_FORMAT = 'HH:mm:ss'
export const DATETIME_FORMAT = 'MM/DD/YYYY HH:mm'

// User Roles
export const USER_ROLES = {
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  USER: 'User',
}

// Status Options
export const STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PENDING: 'Pending',
  SUSPENDED: 'Suspended',
}

// Chart Colors
export const CHART_COLORS = {
  PRIMARY: '#02c0a7',
  SUCCESS: '#10b981',
  WARNING: '#f59e0b',
  DANGER: '#ef4444',
  INFO: '#06b6d4',
  PURPLE: '#8b5cf6',
}

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
}
